import React, { lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { webRoute } from "./config/route";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {webRoute.map((routeItem) => {
          return (
            <Route
              key={routeItem.key}
              path={routeItem.path}
              element={routeItem.element}
            />
          );
        })}
      </Routes>
    </BrowserRouter>
  );
};

export default App;
